import {
    WhatsAppOutlined,
    MessageOutlined,
    FacebookOutlined,
    InstagramOutlined
} from '@ant-design/icons';

export const getPlatformConfig = (channelType, t, isDarkMode) => {
    switch (channelType?.toLowerCase()) {
        case 'whatsapp':
            return {
                icon: WhatsAppOutlined,
                color: '#25D366',
                name: t('whatsapp')
            };
        case 'facebook_page':
            return {
                icon: FacebookOutlined,
                color: '#1877F2',
                name: t('facebook')
            };
        case 'instagram':
            return {
                icon: InstagramOutlined,
                color: '#E4405F',
                name: t('instagram')
            };
        default:
            return {
                icon: MessageOutlined,
                color: isDarkMode ? '#8c8c8c' : '#595959',
                name: t('unknown')
            };
    }
};
